import { writable, derived, type Writable } from 'svelte/store';
import hexRgb from 'hex-rgb';
import { tweened } from 'svelte/motion';
import { sineInOut } from 'svelte/easing';

export type ColorPosition = {
  color: string;
  position: number;
};

export type Gradient = {
  gradient: ColorPosition[];
  baseColor: string;
};

export const transitionAmount = tweened(0, {
  duration: 100,
  easing: sineInOut
});

export const GradientConfig: Writable<Gradient> = writable();

export const Colors = derived(GradientConfig, ($config) =>
  $config.gradient
    .map((p: ColorPosition) => {
      const { red, green, blue } = hexRgb(p.color);
      return [red / 255, green / 255, blue / 255];
    })
    .flat()
);

export const Positions = derived(GradientConfig, ($config) =>
  $config.gradient.map((p: ColorPosition) => p.position)
);

export const BaseColor = derived(GradientConfig, ($config) => {
  const { red, green, blue } = hexRgb($config.baseColor);
  return [red / 255, green / 255, blue / 255];
});
